import {
    FETCH_TAGS_REQUEST,
    GET_TAGS,
    TAGS_ERROR,
    GET_SINGLE_TAG,
    SET_CLICKED_TAG,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const fetchTagsRequest = () => {
        return {
            type: FETCH_TAGS_REQUEST,
        };
    };

    const getTags = (tags) => {
        return {
            type: GET_TAGS,
            payload: tags,
        };
    };

    const getSingleTag = (singleTag) => {
        return {
            type: GET_SINGLE_TAG,
            payload: singleTag,
        };
    };

    const tagsError = (error) => {
        return {
            type: TAGS_ERROR,
            payload: error,
        };
    };

    const setClickedTag = (tag) => {
        // debugger
        return {
            type: SET_CLICKED_TAG,
            payload: tag,
        };
    };

    const fetchAllTags = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchTagsRequest);
                var response = await axiosCall.get(`tags/`);
                const tags = response.data;
                dispatch(getTags(tags));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(tagsError(errorMsg));
            }
        };
    };

    const saveEditedTagInfo = (editedTagInfo) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `tags/` + editedTagInfo.id,
                    editedTagInfo
                );
                dispatch(getTags(editedTagInfo));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(tagsError(errorMsg));
            }
        };
    };

    return {
        fetchTagsRequest,
        getTags,
        getSingleTag,
        tagsError,
        setClickedTag,
        fetchAllTags,
        saveEditedTagInfo,
    };
};

export default initActions;
